import { useTranslation as useTranslationI18Next } from 'react-i18next';

import { getAppConfig } from '@config/get-app-config';

const { site } = getAppConfig();

export const useTranslation = () => {
  const useTranslationHook = useTranslationI18Next(
    `checkout-assets/checkout-frontend/locales/${site.realm}`,
  );
  return {
    ...useTranslationHook,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t: (key: string, values?: any) => useTranslationHook.t(key, { ...values }),
  };
};
